const summe = (werte) => {
    const vorhanden = werte.filter((wert) => wert !== null);
    return vorhanden.length === 0 ? null : vorhanden.reduce((a, b) => a + b, 0);
};
const anteil = (wert, nenner) => wert === null || nenner === null || nenner <= 0 ? null : ((wert - nenner) / nenner) * 100;
export const summarisePortfolio = (positions) => {
    const mitBestand = positions.filter((position) => position.marketValue !== null);
    const costBasis = summe(mitBestand.map((position) => position.costBasis));
    const marketValue = summe(mitBestand.map((position) => position.marketValue));
    /*
     * Für die Stop-Summe zählen nur Positionen, die tatsächlich einen Stop haben.
     * Für die übrigen den Marktwert einzusetzen wäre bequem und falsch: Das
     * unterstellte einen Boden, den es nicht gibt. Stattdessen wird gezählt, wie
     * viele fehlen — die Oberfläche macht es dann kenntlich.
     */
    const mitStop = mitBestand.filter((position) => position.stopLossValue !== null);
    const stopLossValue = summe(mitStop.map((position) => position.stopLossValue));
    /* Der Nenner folgt dem Zähler, sonst vergleicht der Prozentwert Ungleiches. */
    const stopCostBasis = summe(mitStop.map((position) => position.costBasis));
    return {
        marketValue,
        costBasis,
        unrealisedPercent: anteil(marketValue, costBasis),
        stopLossValue,
        stopLossPercent: anteil(stopLossValue, stopCostBasis),
        ohneBestand: positions.length - mitBestand.length,
        ohneStop: mitBestand.length - mitStop.length,
    };
};
//# sourceMappingURL=portfolio-summary.js.map